'use strict';

var React = require('react');

var SvgPaperCheckMinor = function SvgPaperCheckMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.071 4.06a1.5 1.5 0 1 1 2.121 2.122l-2.12-2.121Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.364 4.768 2.121 2.121-4.95 4.95-2.474.353.353-2.474 4.95-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-1v2h1v5h-12v-5h1v-2h-1Z"
  }));
};

exports.SvgPaperCheckMinor = SvgPaperCheckMinor;
